import React from 'react';
import { Code2, Globe, Cloud, GitMerge, Lightbulb, Settings } from 'lucide-react';

const services = [
  {
    icon: Code2,
    title: 'Custom ERP Development',
    description:
      'End-to-end ERP systems tailored to streamline operations, automate workflows, and improve business visibility.'
  },
  {
    icon: Globe,
    title: 'Web & Application Development',
    description:
      'Modern, scalable web and mobile applications built with robust architecture and clean user experience.'
  },
  {
    icon: GitMerge,
    title: 'System Architecture & Integration',
    description:
      'Well-structured system design and seamless integration between services, APIs, and third-party platforms.'
  },
  {
    icon: Lightbulb,
    title: 'IT Consulting & Digital Strategy',
    description:
      'Technology advisory and solution planning to help businesses choose the right systems and scale efficiently.'
  },
  {
    icon: Settings,
    title: 'Maintenance & Technical Support',
    description:
      'Ongoing improvements, optimization, and technical support to ensure long-term system stability.'
  }
];

const Services = () => {
  return (
    <section id="services" className="relative py-16 sm:py-24 md:py-32 px-4 sm:px-6" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16" data-aos="fade-up">
          <h2 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4" data-testid="services-title">Our Services</h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm sm:text-base px-4">
            Comprehensive IT solutions to power your digital transformation
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div 
                key={index}
                className="glass-card p-6 sm:p-8 group"
                data-aos="fade-up"
                data-aos-delay={index * 100}
                data-testid={`service-card-${index}`}
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#00E5FF]/10 flex items-center justify-center mb-4 sm:mb-6 group-hover:bg-[#00E5FF]/20 transition-colors">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-[#00E5FF]" />
                </div>
                <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3" data-testid={`service-title-${index}`}>{service.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
